module.exports = __webpack_public_path__ + "static/media/Mexico.1610bfb5.svg";